import React from 'react';
import { AlertCircle, VideoOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../ui/button';

interface InvalidSessionProps {
    icon?: React.ReactNode;
    title?: string;
    message?: string;
    buttonText?: string;
    onButtonClick?: () => void;
}

const InvalidSession: React.FC<InvalidSessionProps> = ({
    icon,
    title = "Invalid Session",
    message = "The session ID you provided is either incorrect or the session no longer exists. Please check the link or return to the dashboard to start a new session.",
    buttonText = "Back to Dashboard",
    onButtonClick,
}) => {
    const navigate = useNavigate();
    const handleBack = onButtonClick || (() => navigate('/dashboard'));
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#FFF8F0]">
            <div className="text-center p-8">
                {icon || <AlertCircle className="w-16 h-16 mx-auto text-red-400 mb-4" />}
                <h1 className="text-2xl font-bold text-gray-900 mb-2">{title}</h1>
                <p className="text-gray-600 mb-6 max-w-md">{message}</p>
                <Button variant="destructive" onClick={handleBack}>
                    {buttonText}
                </Button>
            </div>
        </div>
    );
};

export default InvalidSession;
